import { iGetActiveOptionsQueryResponse, iGetOptionOrdersQueryResponse } from "../interfaces/chrInterfaces";
import { getTokenCurrencyByAddr } from "../utils/helpers";
import { iClientOrderOption, iOrder, iOrderResponse, iTableOrder } from "../interfaces/interfaces";
import { cChromiaOrder } from "./chromiaOrder";
import { cBigNumber } from "./BigNumber";
import { cStrike } from "./strike";


export class cClientOrderOption implements iClientOrderOption {
	optId!: string;
	fTokenCurrency!: string;
	fTokenAddress!: string;
	uTokenCurrency!: string;
	uTokenAddress!: string;
	optionType!: boolean; // true => call, false => put
	optionTypeText!: 'Put' | 'Call';
	strike!: cStrike;
	// create_time: number;
	maturityTime!: number;
	period!: "daily" | "weekly";
	maturityPrice!: cBigNumber;
	order!: iTableOrder;

	// constructor(responseOption: iOption, order: iGetOptionOrdersQueryResponse){
	constructor(responseOption: iGetActiveOptionsQueryResponse | null, order: iGetOptionOrdersQueryResponse | null, timestamp: number, orderResponse?: iOrderResponse){
		if (responseOption && !orderResponse){
			this.optId = responseOption.id.toString('hex');

			this.fTokenAddress = responseOption.ft.toString('hex');
			this.uTokenAddress = responseOption.ut.toString('hex');

			this.fTokenCurrency = getTokenCurrencyByAddr(this.fTokenAddress);
			this.uTokenCurrency = getTokenCurrencyByAddr(this.uTokenAddress);

			this.optionType = Boolean(responseOption.is_call);
			this.optionTypeText = this.optionType? 'Call' : 'Put';

			this.strike = new cStrike(responseOption.strike_price);

			// this.create_time = response_option.create_time;
			this.maturityTime = responseOption.mat_time;
			this.maturityPrice = new cBigNumber(responseOption.mat_price);

			this.order = {
				...new cChromiaOrder(order!, this.uTokenCurrency),
				isExpired: timestamp > this.maturityTime
			};

			// period
			// if (response_option.maturity_time - response_option.create_time < 60*60*48){
			// 	this.period = 'daily';
			// } else {
				// this.period = 'weekly';
				this.period = 'daily';
			// }		
		
		} else if (orderResponse) {
			this.optId = orderResponse.ord_id.toString();
			this.fTokenAddress = orderResponse.option!.f_token;
			this.uTokenAddress = orderResponse.option!.u_token;

			this.fTokenCurrency = getTokenCurrencyByAddr(this.fTokenAddress);
			this.uTokenCurrency = getTokenCurrencyByAddr(this.uTokenAddress);

			this.optionType = Boolean(orderResponse.option!.call_type);
			this.optionTypeText = this.optionType? 'Call' : 'Put';

			this.strike = new cStrike(orderResponse.option!.strike);

			// this.create_time = response_option.create_time;
			this.maturityTime = orderResponse.option!.maturity_time;
			this.maturityPrice = new cBigNumber(orderResponse.option!.maturity_price);

			const curPrice = new cBigNumber(orderResponse.ord_price)
			const min_max_price = new cBigNumber(orderResponse.min_max_price)
			this.order = {
				ordId: orderResponse.ord_id,
				ordType: orderResponse.ord_type,
				optId: orderResponse.opt_id,
				refPrice: new cBigNumber(orderResponse.ref_price),
				ordPrice: new cBigNumber(orderResponse.ord_price),
				minMaxPrice: min_max_price,
				owner: orderResponse.owner,
				amount: new cBigNumber(orderResponse.amount),
				delta: new cBigNumber(orderResponse.delta),
				
				currentPrice: orderResponse.ord_type
				? curPrice.lt(min_max_price)? min_max_price : curPrice
				: curPrice.gt(min_max_price)? min_max_price : curPrice,
				
				isExpired: timestamp > this.maturityTime
			};

			this.period = 'daily';
		}
	}
}